import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useMerchantsListQuery } from '~platform/entities/merchant';
import { useGetPointsOfSalesQuery } from '~platform/entities/pos';

import { MultiSelectFilter } from '~shared/ui/multi-select-filter';

import { APPLICATION_STATUS_OPTIONS } from '../../lib/application-status-options';
import {
  getMerchantOptions,
  getStoreOptions,
} from '../../lib/get-applications-filter-options';
import type { ApplicationsFiltersValue } from '../../model/applications-filters';

type FieldProps = {
  onChange?: () => void;
};

export function StatusSelect({ onChange }: FieldProps) {
  return (
    <MultiSelectFilter
      name="statuses"
      label="Status"
      options={APPLICATION_STATUS_OPTIONS}
      onValueChange={onChange}
    />
  );
}

export function BusinessSelect({ onChange }: FieldProps) {
  const { setValue } = useFormContext<ApplicationsFiltersValue>();
  const { data } = useMerchantsListQuery();
  const options = useMemo(() => getMerchantOptions(data ?? []), [data]);

  return (
    <MultiSelectFilter
      name="merchantIds"
      label="Businesses"
      options={options}
      onValueChange={() => {
        setValue('posIds', [], { shouldDirty: true });
        onChange?.();
      }}
    />
  );
}

export function StoreSelect({ onChange }: FieldProps) {
  const { data } = useGetPointsOfSalesQuery();
  const selectedMerchantIds = useWatch<ApplicationsFiltersValue, 'merchantIds'>(
    {
      name: 'merchantIds',
    }
  );
  const options = useMemo(
    () => getStoreOptions(data ?? [], selectedMerchantIds ?? []),
    [data, selectedMerchantIds]
  );

  return (
    <MultiSelectFilter
      name="posIds"
      label="Stores"
      options={options}
      onValueChange={onChange}
    />
  );
}
